module.exports = __webpack_public_path__ + "img/card_style.3f3cd134.svg";